import {Breadcrumbs, ErrorPopup, Notice, Title} from '@management-ui/core';
import {reverse} from 'named-urls';
import React from 'react';
import routes from '../../../../routes';


const Wrapper = ({title, loading, titleControls, company, crumbs, errors, children}) => {
  return (
    <>
      <Breadcrumbs crumbs={crumbs}/>
      <Title title={title} loading={loading} controls={titleControls}/>
      <Notice
        display={company && company.archived}
        message={[
          'This company has been archived and is therefore no longer available.',
          'You won\'t be able to modify it unless it is restored.'
        ].join(' ')}
      />
      {children}
      <ErrorPopup errors={['company']} messages={errors}/>
    </>
  );
}

Wrapper.standardCrumbs = [
  {title: 'Companies', link: routes.companies.index}
];
Wrapper.archiveCrumbs = [
  {title: 'Archive', link: reverse(routes.archive.index)},
  {title: 'Companies', link: reverse(routes.archive.index, {tab: 'companies'})}
];

export default Wrapper;
